<section class="page">
  <div class="page-header">
    <h1>Telefonnummer bestätigen</h1>
    <p>Geben Sie den Code ein, der an Ihre Telefonnummer gesendet wurde.</p>
  </div>

  <mat-card class="verification-card">
    <p class="phone-info">Code gesendet an: {{ maskedPhone }}</p>

    <app-error-banner [message]="errorMessage"></app-error-banner>
    <app-error-banner [message]="rateLimitMessage" type="warning"></app-error-banner>

    <div class="info-message" *ngIf="infoMessage">{{ infoMessage }}</div>

    <app-sms-code-input [disabled]="isVerifying" (codeChange)="onCodeChange($event)"></app-sms-code-input>

    <div class="countdown" *ngIf="remainingSeconds > 0">
      Neuer Code verfügbar in {{ remainingSeconds }} Sekunden.
    </div>

    <div class="action-stack">
      <button mat-flat-button color="primary" [disabled]="!canVerify" (click)="verify()">
        Bestätigen
      </button>
      <button mat-stroked-button color="primary" [disabled]="resendDisabled" (click)="sendCode()">
        Code erneut senden
      </button>
      <button mat-button type="button" (click)="back()">Zurück</button>
    </div>
  </mat-card>
</section>
